// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".BMapLabel{border:none!important;background:transparent!important}#HPIndex .warning-row{background:rgba(245,108,108,.1);color:#f56c6c}", ""]);
// Exports
module.exports = exports;
